/**
 * Dashboard KPI drill-down API — pending payments, billed pay apps, collected MTD.
 */

import { apiFetch } from './client'

export interface OutstandingPayApp {
  id: number
  pay_app_number: number
  amount_due: string
  amount_paid: string | null
  payment_due_date: string | null
  payment_status: string | null
  project_name: string
  project_id: number
  owner_name: string | null
  days_overdue: number
  urgency: 'overdue' | 'due_soon' | 'current'
}

export interface BilledPayApp {
  id: number
  app_number: number
  amount_due: string
  status: string
  submitted_at: string | null
  payment_status: string | null
  project_id: number
  project_name: string
  owner: string | null
}

export interface CollectedPayment {
  id: number
  pay_app_id: number
  project_id: number
  amount: string
  payment_method: string
  payment_status: string
  paid_at: string | null
  created_at: string
  app_number: number
  project_name: string
  source: 'manual' | 'stripe'
}

export async function fetchOutstandingPayApps(): Promise<OutstandingPayApp[]> {
  const res = await apiFetch<{ ok: boolean; data: OutstandingPayApp[] }>(
    'GET',
    '/api/collection/outstanding',
  )
  return res.data ?? []
}

export async function fetchBilledPayApps(): Promise<BilledPayApp[]> {
  const res = await apiFetch<{ ok: boolean; data: BilledPayApp[] }>(
    'GET',
    '/api/reports/billed-pay-apps',
  )
  return res.data ?? []
}

export async function fetchCollectedMtd(): Promise<CollectedPayment[]> {
  const res = await apiFetch<{ ok: boolean; data: CollectedPayment[] }>(
    'GET',
    '/api/reports/collected-mtd',
  )
  return res.data ?? []
}
